// Shared identifiers for the React Flow node `type` discriminator and the
// handle IDs used on each node kind. Centralised so editor, canvas, layout,
// and execution view all reference the same string literals.

export const TRIGGER = "trigger" as const
export const CONDITION = "condition" as const
export const ACTION = "action" as const

export type NodeKind = typeof TRIGGER | typeof CONDITION | typeof ACTION

/** Default source/target handle id used by trigger and action nodes, and
 *  the target handle id used by every node. */
export const HANDLE_OUTPUT = "output" as const
export const HANDLE_INPUT = "input" as const

/** Source handle ids on a condition node — one per branch. */
export const HANDLE_THEN = "true-output" as const
export const HANDLE_OTHERWISE = "false-output" as const

export type ConditionBranchHandle = typeof HANDLE_THEN | typeof HANDLE_OTHERWISE
